import React, { useContext, useState } from 'react'
import { CheckIcon, ChevronDownIcon } from '@chakra-ui/icons'
import { Box, Button, Checkbox, HStack, Menu, MenuButton, MenuItem, MenuList, Text, VStack } from '@chakra-ui/react'
import { EBreakPoint, EZIndexLayer } from 'enums/theme'
import useBreakPoint from 'hooks/useBreakPoint'
import get from 'lodash/get'
import { useFormContext } from 'react-hook-form'
import { toast } from 'react-toastify'
import FormInput from 'components/FormInput'
import { getValidArray } from 'utils/common'
import { ApplicationContext } from '../../applicationForm.context'
import { BottomButton, BottomBackButton } from '../../applicationFormModalV2.styles'
import { DESKTOP_CONTAINER_WIDTH, EBottomButtonValue, refererSource } from '../../constant'

const SelectSource = () => {
  const { checkedItems, setCheckedItems, handleNextStep, handlePreviousStep } = useContext(ApplicationContext)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const checkItemLength: number = getValidArray(checkedItems).length
  const buttonText: string = `${getValidArray(checkedItems)[0]}${
    checkItemLength > 1 ? `, +${checkItemLength - 1}` : ''
  }`
  const { setValue } = useFormContext()
  const isDesktop: boolean = useBreakPoint(EBreakPoint.LG)

  function toggleChecked(item: string): void {
    const validCheckedItems: string[] = getValidArray(checkedItems)

    if (typeof setCheckedItems === 'function') {
      if (validCheckedItems.findIndex((checkedItem) => checkedItem === item) > -1) {
        const filteredItems: string[] = validCheckedItems.filter((currentItem) => currentItem !== item)

        setCheckedItems(filteredItems)
        setValue('referrers', filteredItems)
      } else {
        const newCheckedItems: string[] = [...validCheckedItems, item]

        setCheckedItems(newCheckedItems)
        setValue('referrers', newCheckedItems)
      }
    }
  }

  async function handleSubmitForm(): Promise<void> {
    try {
      typeof handleNextStep === 'function' && (await handleNextStep())
    } catch (error) {
      const errorMessage: string = get(error, 'error.message')
      toast.error(errorMessage)
    }
  }

  return (
    <VStack
      maxWidth={{ base: 'full', lg: DESKTOP_CONTAINER_WIDTH }}
      marginX="auto"
      marginTop={{ base: 6, lg: 40 }}
      spacing={8}
      alignItems="flex-start"
      width="full"
      paddingX={{ base: 4, lg: 1 }}
      paddingBottom={{ base: 0, lg: 1 }}
      minHeight={{ lg: isOpen ? '600px' : 'unset' }}
      overflow="hidden"
      height="full"
      marginBottom={{ base: 24, lg: 0 }}
    >
      {isDesktop && (
        <Text fontSize="md" fontWeight="500" color="gray.700">
          Congratulations! <br /> You have been conditionally approved for this unit.
        </Text>
      )}
      <Box width="full">
        <FormInput name="referrers" label="How did you hear about us?" autoComplete="off">
          {isDesktop ? (
            <Menu
              closeOnSelect={false}
              computePositionOnMount
              matchWidth
              onOpen={() => {
                setIsOpen(true)
              }}
              onClose={() => {
                setIsOpen(false)
              }}
            >
              <MenuButton
                as={Button}
                width="full"
                border="1px solid #E2E8F0"
                background="white"
                iconSpacing={5}
                rightIcon={<ChevronDownIcon />}
              >
                <Text fontSize="md" color="gray.700" whiteSpace="nowrap" fontWeight="normal" textAlign="start">
                  {checkItemLength > 0 ? buttonText : 'Select Source'}
                </Text>
              </MenuButton>
              <MenuList zIndex={1500}>
                {refererSource.map((option: string) => (
                  <MenuItem key={option} onClick={() => toggleChecked(option)} cursor="pointer">
                    <Checkbox
                      id={option}
                      isChecked={getValidArray(checkedItems).findIndex((item) => item === option) > -1}
                      marginInlineEnd={3}
                      colorScheme="teal"
                      onMouseDown={() => toggleChecked(option)}
                    />
                    <Text>{option}</Text>
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          ) : (
            <VStack marginLeft={4} width="full" border="none" spacing={4} alignItems="flex-start" paddingTop={2}>
              {refererSource.map((option: string) => (
                <HStack width="stretch" key={`mobile-${option}`} onClick={() => toggleChecked(option)}>
                  <Checkbox
                    id={option}
                    isChecked={getValidArray(checkedItems).findIndex((item) => item === option) > -1}
                    marginInlineEnd={3}
                    colorScheme="teal"
                    onMouseDown={() => toggleChecked(option)}
                  />
                  <Text>{option}</Text>
                </HStack>
              ))}
            </VStack>
          )}
        </FormInput>
      </Box>
      <FormInput
        height={isDesktop ? '40px' : '48px'}
        width="full"
        name="otherReferrer"
        label="Referral's Name (optional)"
        placeholder="Enter Referral's name"
        isRequired={false}
        autoComplete="off"
      />
      <HStack
        width="full"
        height="auto"
        alignItems="flex-end"
        paddingX={{ base: 4, lg: 0 }}
        justifyContent="space-between"
        spacing={2}
        paddingBottom={{ base: 6, md: 12, lg: 'auto' }}
        paddingTop={{ base: 4, lg: 'auto' }}
        position={{ base: 'fixed', lg: 'static' }}
        bottom={0}
        zIndex={EZIndexLayer.MODAL}
        left={0}
        background={{ base: 'white', lg: 'none' }}
      >
        <BottomBackButton onClick={handlePreviousStep} variant="solid">
          {EBottomButtonValue.BACK}
        </BottomBackButton>
        <BottomButton
          onClick={handleSubmitForm}
          colorScheme="teal"
          variant="solid"
          id="submit"
          rightIcon={<CheckIcon />}
        >
          {EBottomButtonValue.COMPLETE}
        </BottomButton>
      </HStack>
    </VStack>
  )
}

export default SelectSource
